__turbopack_context__.v({
  "nav": "styles-module__0w6XZa__nav",
});
